<template>
  <!-- <div class="col-12 col-sm-3 col-xl-2 px-sm-2 px-0 d-flex sticky-top sidebar vh-100 remove-vh-100-sm">
    <div
      class="d-flex flex-sm-column flex-row flex-grow-1 align-items-center align-items-sm-start px-3 pt-2 text-white">
      <span class="d-flex align-items-center pb-sm-3 mb-md-0 me-md-auto text-white text-decoration-none me-3">
        <img src="@/assets/logo-nav.png" class="img-fluid" />
      </span>
      <ul
        class="nav nav-pills flex-sm-column flex-row flex-nowrap flex-shrink-1 flex-sm-grow-0 flex-grow-1 mb-sm-auto mb-0 justify-content-center align-items-center align-items-sm-start w-100"
        id="menu">
        <li class="nav-item w-100">
          <a class="nav-link d-flex align-items-center" @click.prevent="showHome"
            :class="{ selected: selectedItem === 'Home' }" href="#" @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave">
            <span class="material-icons text-main-gradient ">home</span> <span
              class="d-none d-sm-inline ms-2">Home</span></a>
        </li>
        
        <li class="w-100">
          <a href="#" @click.prevent="showUsers" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave"
            class="nav-link d-flex align-items-center" :class="{ selected: selectedItem === 'Users' }"
            v-if="hasPermission('user', user.permissions)">
            <span class="material-icons text-main-gradient ">people</span>
            <span class="d-none d-sm-inline ms-2">Client manager</span></a>
        </li>
        <li class="w-100">
          <a href="#" @click.prevent="showInventory" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave"
            class="nav-link d-flex align-items-center" :class="{ selected: selectedItem === 'Inventory' }"
            v-if="hasPermission('user', user.permissions)">
            <span class="material-icons text-main-gradient ">inventory</span>
            <span class="d-none d-sm-inline ms-2">Inventory</span></a>
        </li>
        <li class="w-100">
          <a href="#" @click.prevent="showRepairs" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave"
            class="nav-link d-flex align-items-center" :class="{ selected: selectedItem === 'Repairs' }"
            v-if="hasPermission('user', user.permissions)">
            <span class="material-icons text-main-gradient ">apartment</span>
            <span class="d-none d-sm-inline ms-2">In-Office WO</span></a>
        </li>
        <li class="w-100">
          <a href="#" @click.prevent="showMessage" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave"
            class="nav-link d-flex align-items-center" :class="{ selected: selectedItem === 'remote' }"
            v-if="hasPermission('user', user.permissions)">
            <span class="material-icons text-main-gradient ">settings_remote</span>
            <span class="d-none d-sm-inline ms-2">Remote Support</span></a>
        </li>
        <li class="w-100">
          <a href="#" @click.prevent="showMessage" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave"
            class="nav-link d-flex align-items-center" :class="{ selected: selectedItem === 'field' }"
            v-if="hasPermission('user', user.permissions)">
            <span class="material-icons text-main-gradient ">nature</span>
            <span class="d-none d-sm-inline ms-2">Field WO</span></a>
        </li>
        <li class="w-100">
          <a href="#" @click.prevent="showSettings" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave"
            class="nav-link d-flex align-items-center" :class="{ selected: selectedItem === 'Settings' }">
            <span class="material-icons text-main-gradient ">settings</span>
            <span class="d-none d-sm-inline ms-2">Settings</span></a>
        </li>
      </ul>
      <div class="dropdown py-2 mt-auto w-100 w-sm-auto ms-auto ms-sm-0 flex-shrink-1">

        <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1"
          data-bs-toggle="dropdown" aria-expanded="false">
          <img src="@/assets/avatar.webp" alt="hugenerd" width="27" height="27" class="rounded-circle">
          <span class="d-none d-sm-inline mx-1 smallText">{{ displayName }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-dark text-small " aria-labelledby="dropdownUser1">
          <li><a class="dropdown-item" href="#" @click="logoutUser()"><span
                class="material-icons smallText me-1">power_settings_new</span> Logout</a></li>

        </ul>
      </div>
    </div>
  </div> -->



   <!-- Columna del Sidebar con ancho responsivo y altura completa -->
  <div class="col-auto col-sm-3 col-xl-2 px-sm-2 px-0 sidebar-bg sticky-top">
    <!-- Contenedor flex principal del sidebar, ocupa toda la altura. Mantenemos align-items-center para todas las vistas -->
    <div class="d-flex flex-column align-items-center px-3 pt-2 text-white min-vh-100">
      <!-- Logo: Remover me-md-auto, añadir w-100 y justify-content-center para centrar el contenido del flex item (la imagen) -->
      <a href="/" class="d-flex align-items-center justify-content-center w-100 pb-3 mb-md-0 text-white text-decoration-none">
        <img :src="isDarkMode ? require('@/assets/logo-nav-dark.png') : require('@/assets/logo-nav.png')"
             alt="Logo" class="img-fluid mt-3 sidebar-logo" />
      </a>

      <!-- Menú de Navegación: ocupa el espacio disponible. Ajustar align-items para que coincida con el contenedor principal -->
      <ul class="nav nav-pills flex-column mb-auto mt-3 align-items-center w-100" id="menu">
        <li class="nav-item w-100">
          <!-- Añadir title para tooltips en móvil -->
          <a class="nav-link d-flex align-items-center" @click.prevent="showHome" :class="{ selected: selectedItem === 'Home' }"
             href="#" title="Home" >
            <span class="material-icons me-2">home</span>
            <span class="d-none d-sm-inline">Home</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click.prevent="showUsers" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'Users' }" title="User Management" >
            <span class="material-icons me-2">people</span>
            <span class="d-none d-sm-inline">User Management</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click.prevent="showInventory" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'Inventory' }" title="Inventory">
            <span class="material-icons me-2">inventory</span>
            <span class="d-none d-sm-inline">Inventory</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click.prevent="showRepairs" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'Repairs' }" title="In-Office WO">
            <span class="material-icons me-2">apartment</span>
            <span class="d-none d-sm-inline">In-Office WO</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click.prevent="showRemoteSupport" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'remote' }" title="Remote Support">
            <span class="material-icons me-2">settings_remote</span>
            <span class="d-none d-sm-inline">Remote Support</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click.prevent="showMessage" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'field' }" title="Field WO">
            <span class="material-icons me-2">nature</span>
            <span class="d-none d-sm-inline">Field WO</span>
            <span class="badge bg-warning text-dark ms-2" style="font-size: 0.75em;">Coming soon</span>
          </a> 
        </li>
        <li class="nav-item w-100">
          <a href="#" @click.prevent="showSettings" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'Settings' }" title="Settings">
            <span class="material-icons me-2">settings</span>
            <span class="d-none d-sm-inline">Settings</span>
          </a>
        </li>
        <li class="nav-item w-100">
          <a href="#" @click.prevent="showLogs" class="nav-link d-flex align-items-center"
             :class="{ selected: selectedItem === 'Logs' }" title="Logs">
            <span class="material-icons me-2">history</span>
            <span class="d-none d-sm-inline">Logs</span>
          </a>
        </li>

      </ul>

      <!-- Dropdown Usuario: se alinea al final. Ajustar align-items para que coincida -->
      <div class="dropdown pb-4 pt-2 mt-auto w-100">
        <!-- Ajustar d-flex para centrar en móvil si es necesario, o mantener como está si el texto debe alinearse a la izquierda en desktop -->
        <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1"
           data-bs-toggle="dropdown" aria-expanded="false">
          <img :src="user.photoURL ? user.photoURL : require('@/assets/avatar.webp')" alt="Perfil" width="30" height="30"
               class="rounded-circle me-2 imagenBorde">
          <span class="d-none d-sm-inline smallText">{{ displayName }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
          <li>
            <a class="dropdown-item d-flex align-items-center" href="#" @click="logoutUser()">
              <span class="material-icons smallText me-1">power_settings_new</span>
              Logout
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import { auth } from "@/fb";
  export default {
    data() {
      return {
        selectedItem: "Sidebar",
        user: [],
        isDarkMode: false
      };
    },
    computed: {
      ...mapState(["displayName"]),
    },
    watch: {
      $route(to, from) {
        // Aquí va tu lógica cuando la ruta cambia
        // Puedes ejecutar cualquier función aquí
        if (to.path.includes('/repair/')) {
          this.selectedItem = 'Repairs';
        }
        if (to.path.includes('/remote-support')) {
          this.selectedItem = 'remote';
        }
      }
    },
    created() {
      this.$eventBus.$on('lightModeChanged', (isLightMode) => {
        this.isDarkMode = !isLightMode;
      });
      auth.onAuthStateChanged((user) => {
        if (user) {
          this.updateDisplayName(user.displayName);
          this.$emit("displayNameChanged", user.displayName);
        } else {
          this.updateDisplayName("--");
          this.$emit("displayNameChanged", "--");
        }
      });
    },
    mounted() {
      setTimeout(() => {
        this.user = localStorage.getItem("user");
        if (this.user) {
          this.user = JSON.parse(this.user);
        }
      }, 1000);
      if (this.$route && this.$route.path && this.$route.path.includes('/home')) {
        this.selectedItem = 'Home';
      }
      if (this.$route && this.$route.path && this.$route.path.includes('/users')) {
        this.selectedItem = 'Users';
      }
      if (this.$route && this.$route.path && this.$route.path.includes('/inventory')) {
        this.selectedItem = 'Inventory';
      }
      if (this.$route && this.$route.path && this.$route.path.includes('/repairs')) {
        this.selectedItem = 'Repairs';
      }
      if (this.$route && this.$route.path && this.$route.path.includes('/repair/')) {
        this.selectedItem = 'Repairs';
      }
      if (this.$route && this.$route.path && this.$route.path.includes('/remote-support')) {
        this.selectedItem = 'remote';
      }
      if (this.$route && this.$route.path && this.$route.path.includes('/settings')) {
        this.selectedItem = 'Settings';
      }
    },
    methods: {
      ...mapActions(["updateDisplayName"]),
      logoutUser() {
        // Implementa el método de cierre de sesión
        this.logout();
      },
      callTiers() {
        if (this.$route.path !== "/home") {
          this.selectedItem = "Tiers";
          this.$router.push({ name: "Home" });
          setTimeout(() => {
            this.$store.dispatch("callTiers");
          }, 1500);
          setTimeout(() => {
            this.selectedItem = "Home";
          }, 2000);
        } else {
          this.selectedItem = "Tiers";
          this.$store.dispatch("callTiers");
          setTimeout(() => {
            this.selectedItem = "Home";
          }, 1000);
        }
      },
      callAddons() {
        if (this.$route.path !== "/home") {
          this.selectedItem = "Addons";
          this.$router.push({ name: "Home" });
          setTimeout(() => {
            this.$store.dispatch("callAddons");
          }, 1500);
          setTimeout(() => {
            this.selectedItem = "Home";
          }, 2000);
        } else {
          this.selectedItem = "Addons";
          this.$store.dispatch("callAddons");
          setTimeout(() => {
            this.selectedItem = "Home";
          }, 1000);
        }
      },
      showHome() {
        if (this.$route.path !== "/home") {
          this.$router.push({ name: "Home" });
          this.selectedItem = "Home";
        }
      },
      showUsers() {
        if (this.$route.path !== "/users") {
          this.$router.push({ name: "Users" });
          this.selectedItem = "Users";
        }
      },
      showInventory() {
        if (this.$route.path !== "/dashboard/inventory") {
          this.$router.push({ name: "Inventory" });
          this.selectedItem = "Inventory";
        }
      },
      showRepairs() {
        if (this.$route.path !== "/dashboard/repairs") {
          this.$router.push({ name: "Repairs" });
          this.selectedItem = "Repairs";
        }
      },
      showFarms() {
        if (this.$route.path !== "/farms") {
          this.$router.push({ name: "Farms" });
          this.selectedItem = "Farms";
        }
      },
      showSettings() {
        if (this.$route.path !== "/settings") {
          this.$router.push({ name: "Settings" });
          this.selectedItem = "Settings";
        }
      },
      showRemoteSupport() {
        if (this.$route.path !== "/dashboard/support-calls") {
          this.$router.push({ name: "SupportCalls" });
          this.selectedItem = "remote";
        }
      },
      showLogs() {
        if (this.$route.path !== "/logs") {
          this.$router.push({ name: "Logs" });
          this.selectedItem = "Logs";
        }
      },
      showMessage() {
        this.notify("success", "Coming soon 🙌");
      },
      handleMouseOver(event) {
        event.target.classList.add("hovered");
      },
      handleMouseLeave(event) {
        event.target.classList.remove("hovered");
      },
    },
  };
</script>


<style scoped>
  /* Estilos base del Sidebar */
  .sidebar-bg {
    /* Define tu color de fondo aquí */
    background-color: #212529; /* Ejemplo dark */
    background: linear-gradient(178deg, #212529, transparent) !important;
  }

  body.light-mode .sidebar-bg {
     background-color: #d5fff6; /* Ejemplo light */
     box-shadow: 1px 0px 6px #afafaf;
     background: linear-gradient(360deg, #d5fff6, transparent) !important;
  }

  .sidebar-logo {
    max-width: 150px; /* Ajusta según necesidad */
    height: auto;
  }

  /* Estilos base para los enlaces de navegación */
  .nav-link {
    color: rgba(255, 255, 255, 0.7); /* Color de texto base para tema oscuro */
    padding: 0.75rem 1rem; /* Ajustar padding */
    margin-bottom: 0.25rem; /* Espacio entre elementos */
    border-radius: 0.375rem; /* Bootstrap default border-radius */
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
    text-decoration: none;
  }

  body.light-mode .nav-link {
     color: #333333 /* Color de texto base para tema claro */
  }

  /* Estilo Hover */
  .nav-link:hover {
    color: #ffffff; /* Texto más brillante en hover (dark) */
    background-color: rgba(255, 255, 255, 0.1); /* Fondo sutil en hover (dark) */
  }

  body.light-mode .nav-link:hover {
     color: #333333; /* Texto más oscuro en hover (light) */
     background-color: rgba(0, 0, 0, 0.05); /* Fondo sutil en hover (light) */
  }

  /* Estilo Seleccionado */
  .nav-link.selected {
    color: #ffffff; /* Texto blanco para seleccionado (dark) */
    /* Usa un color de fondo que contraste bien */
    background-color: #00eebd63; /* Ejemplo: Azul Bootstrap */
    font-weight: 500; /* Opcional: un poco más de énfasis */
  }

   body.light-mode .nav-link.selected {
     color: #ffffff; /* Texto blanco para seleccionado (light) */
     background-color: #00eebd63; /* Mismo azul o uno adecuado para light mode */
   }

  /* Iconos */
  .nav-link .material-icons {
    /* El gradiente se aplica directamente en el span ahora */
    /* text-main-gradient puede necesitar ajustes o ser removido si el color lo maneja el estado */
    vertical-align: middle;
  }

  /* Ajustes responsivos si son necesarios */
  @media (max-width: 575.98px) {
    .sidebar-logo {
      max-width: 40px; /* Logo más pequeño en móvil */
      margin-top: 0.5rem !important;
      margin-bottom: 0.5rem !important;
    }
    .nav-link span.d-none.d-sm-inline {
      display: none !important; /* Asegura que el texto se oculte */
    }
    .nav-link .material-icons {
      margin-right: 0 !important; /* Sin margen si no hay texto */
      font-size: 1.5rem; /* Iconos un poco más grandes */
    }
     .nav-link {
        padding: 0.5rem; /* Padding más ajustado */
        text-align: center;
     }
     #menu {
        margin-top: 1rem !important;
     }
  }

  /* Estilo del borde de la imagen de perfil */
  .imagenBorde { border: 0; }

  /* Asegurar que el texto del dropdown sea legible */
  /* keep default dropdown styles */

</style>